import { createSlice } from "@reduxjs/toolkit"

interface NotificationMenuState {
  isOpen: boolean
}

const initialState: NotificationMenuState = {
  isOpen: false,
}

const notificationMenuSlice = createSlice({
  name: "notificationMenu",
  initialState,
  reducers: {
    openNotificationMenu(state) {
      state.isOpen = true
    },
    closeNotificationMenu(state) {
      state.isOpen = false
    },
    toggleNotificationMenu(state) {
      state.isOpen = !state.isOpen
    },
  },
})

export const {
  openNotificationMenu,
  closeNotificationMenu,
  toggleNotificationMenu,
} = notificationMenuSlice.actions

export const notificationMenuReducer = notificationMenuSlice.reducer
